import { lazy } from 'react';
import { retry } from '../../../config/utils';

const Repayment = lazy(() => retry(()=> import(/* webpackChunkName: "PartnerUploadLoan" */ "./index")));

export default Repayment;